import { createElement } from 'react';
import { FullScreenContainer } from '@jiaminghi/data-view-react';
const DataVFullScreenContainer = (props) => {
    return createElement(FullScreenContainer, { ...props });
};
export default DataVFullScreenContainer;
